import { render, staticRenderFns } from "./MainChart.vue?vue&type=template&id=60234852&scoped=true&"
import script from "./MainChart.vue?vue&type=script&lang=js&"
export * from "./MainChart.vue?vue&type=script&lang=js&"
import style0 from "./MainChart.vue?vue&type=style&index=0&id=60234852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60234852",
  null
  
)

export default component.exports